<template>
  <header class="mtx-header flex justify-between align-center px-2 py-1">
    <button class="btn btn--link" aria-label="Menu" @click="$emit('toggleMenu')">
      <MtxSvg class="mtx-header__hamburger" icon="icon-menu" />
    </button>

    <div class="flex-grow text-right mr-2">
      <NetworkIndicator :networkId="web3.network" />
    </div>

    <button v-if="!user.ethAddress" @click="signIn" :disabled="isLoading" class="btn--clear">
      {{ isLoading ? "Loading..." : "Sign In" }}
    </button>

    <MtxDropdown
      v-else
      :options="{
        placement: 'bottom-end',
        modifiers: { offset: { offset: '0,14px' } }
      }"
    >
      <button class="btn--link" slot="trigger">
        <MtxBlockie :input="user.ethAddress" />
      </button>

      <ul class="list-plain">
        <li>{{ web3.mtxBalance | mtx }}</li>
        <li><router-link to="/account">Account</router-link></li>
        <li><button class="btn--link" @click="logout">Sign Out</button></li>
      </ul>
    </MtxDropdown>
  </header>
</template>

<script>
import { mapState, mapActions } from "vuex"
import NetworkIndicator from "@/components/misc/NetworkIndicator"
import web3 from "@/mixins/web3"

export default {
  components: {
    NetworkIndicator
  },

  mixins: [web3],

  data: () => ({
    isLoading: false
  }),

  computed: {
    ...mapState(["user"])
  },

  methods: {
    ...mapActions(["logout"]),

    async signIn() {
      if (this.isLoading) return
      this.isLoading = true
      await this.requireWeb3()
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss">
.mtx-header {
  position: sticky;
  z-index: 10;
  top: 0;

  height: 60px;
  background: $offBlack;
  box-shadow: 0 0 100px -25px $blue;

  .icon-menu {
    font-size: rem($size4);
  }
}
</style>
